import { Box, Button } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { Screen } from "@outschool/ui-utils";
import React from "react";

export default function FilterActionButtons({ onApply, onCancel }: $TSFixMe) {
  const { t } = useTranslation(
    "client\\components\\search\\desktop\\FilterActionButtons"
  );
  const isMobile = Screen.useIsMobile();
  return (
    <Box
      flex
      sx={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        minWidth: "200px",
        paddingTop: "1em",
        background: "white",
        boxShadow: "0 -1px 0 rgba(0, 0, 0, 0.15)",
        ...(isMobile
          ? {
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              paddingX: "1em",
              paddingBottom: "1em",
              boxShadow: "0 0px 10px 0px rgba(0,0,0,0.5)"
            }
          : {})
      }}
    >
      <Button variant="link" onClick={onCancel}>
        {t("Cancel")}
      </Button>
      <Button variant="contained" onClick={onApply}>
        {t("Apply")}
      </Button>
    </Box>
  );
}
